<template>
  <div class="vip-subscription-container">
    <div class="vip-subscription">
      <!-- 页面标题栏 -->
      <div class="page-header" role="banner">
        <button 
          class="back-btn" 
          @click="$router.go(-1)"
          aria-label="返回上一页"
          title="返回上一页"
        >
          <i class="el-icon-arrow-left"></i>
        </button>
        <h1 class="page-title" tabindex="-1">开通会员</h1>
      </div>

      <!-- 会员套餐卡片区域 -->
      <section class="subscription-plans">
        <div class="plan-card first-purchase" :class="{ highlighted: selectedPlan === 'continuous-monthly' }" @click="selectPlan('continuous-monthly')">
          <div class="tag">首购特惠</div>
          <div class="plan-type">连续包月</div>
          <div class="price">
            <span class="current-price">¥99</span>
            <span class="original-price">¥129</span>
          </div>
          <div class="period">首月</div>
        </div>

        <div class="plan-card first-purchase" :class="{ highlighted: selectedPlan === 'continuous-quarterly' }" @click="selectPlan('continuous-quarterly')">
          <div class="tag">首购特惠</div>
          <div class="plan-type">连续包季</div>
          <div class="price">
            <span class="current-price">¥267</span>
            <span class="original-price">¥387</span>
          </div>
          <div class="period">首季</div>
        </div>

        <div class="plan-card first-purchase" :class="{ highlighted: selectedPlan === 'quarterly' }" @click="selectPlan('quarterly')">
          <div class="tag">首购特惠</div>
          <div class="plan-type">季卡</div>
          <div class="price">
            <span class="current-price">¥285</span>
            <span class="original-price">¥387</span>
          </div>
        </div>

        <div class="plan-card first-purchase" :class="{ highlighted: selectedPlan === 'yearly' }" @click="selectPlan('yearly')">
          <div class="tag">首购特惠</div>
          <div class="plan-type">年卡</div>
          <div class="price">
            <span class="current-price">¥948</span>
            <span class="original-price">¥1548</span>
          </div>
        </div>

        <div class="plan-card" :class="{ highlighted: selectedPlan === 'monthly' }" @click="selectPlan('monthly')">
          <div class="plan-type">月卡</div>
          <div class="price">
            <span class="current-price">¥129</span>
          </div>
        </div>
      </section>

      <div class="disclaimer" v-if="disclaimerText">{{ disclaimerText }}</div>

      <!-- 权益对比表格 -->
      <section class="benefits-comparison">
        <h2 class="section-title">权益对比</h2>
        <div class="comparison-table">
          <div class="table-header">
            <div class="table-header-cell">功能</div>
            <div class="table-header-cell vip-header">会员</div>
            <div class="table-header-cell non-vip-header">非会员</div>
            <div class="table-header-cell new-user-header">新注册用户</div>
          </div>
          
          <!-- 权益行 -->
          <div
            v-for="(item, index) in benefits"
            :key="index"
            class="table-row"
            :class="{ 'row-even': index % 2 === 1 }"
          >
            <div class="row-label">{{ item.name }}</div>
            <div class="table-cell vip-cell">{{ item.vip }}</div>
            <div class="table-cell non-vip-cell">{{ item.non_vip }}</div>
            <div class="table-cell new-user-cell">{{ item.new_user }}</div>
          </div>
        </div>
      </section>

      <!-- 桌面端支付区域 -->
      <section class="payment-section desktop-only">
        <div class="payment-info">
          <div class="total-price">¥{{ selectedPrice }}</div>
          <div class="payment-qrcode">
            <div class="loading" v-if="isLoadingQrCode">
              <div class="spinner"></div>
              <span>加载中...</span>
            </div>
            <img :src="qrCodeUrl" alt="支付宝支付二维码" class="qrcode-img" v-else-if="qrCodeUrl">
            <div class="placeholder-message" v-else-if="!agreedToTerms">
              <i class="fas fa-info-circle"></i>
              <span>请勾选协议获取付款二维码</span>
            </div>
            <div class="error-message" v-else>
              <i class="fas fa-exclamation-circle"></i>
              <span>二维码加载失败，请重试</span>
            </div>
            <div class="payment-methods">
              <div class="terms-agreement">
                <label class="agreement-label">
                  <input type="checkbox" v-model="agreedToTerms" @change="handleAgreementChange">
                  <span v-if="isContinuousPlan">
                    我已阅读并同意
                    <a @click="openVipService($event)" class="agreement-link">《会员服务协议》</a>
                    和
                    <a @click="openContinueService($event)"  class="agreement-link">《自动扣费协议》</a>
                    虚拟商品一经支付不支持退款
                  </span>
                  <span v-else>
                    我已阅读并同意
                    <a @click.default.stop="openVipService($event)" class="agreement-link">《会员服务协议》</a>
                    虚拟商品一经支付不支持退款
                  </span>
                </label>
              </div>
              <img src="@/assets/image/pay/zfb.png" alt="alipay" class="icon_item" style="width: 20px;">
              <span class="scan-text">{{ paymentMessage || '请使用支付宝扫码完成支付' }}</span>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 移动端支付区域（固定在底部） -->
    <section class="mobile-payment-section mobile-only">
      <div class="terms-agreement">
        <label class="agreement-label">
          <input type="checkbox" v-model="agreedToTerms">
          <span v-if="isContinuousPlan">
            我已阅读并同意
            <a @click="openVipService($event)" class="agreement-link">《会员服务协议》</a>
            和
            <a @click="openContinueService($event)"  class="agreement-link">《自动扣费协议》</a>
            虚拟商品一经支付不支持退款
          </span>
          <span v-else>
            我已阅读并同意
            <a @click="openVipService($event)" class="agreement-link">《会员服务协议》</a>
            虚拟商品一经支付不支持退款
          </span>
        </label>
      </div>
      <button class="pay-btn" :disabled="!agreedToTerms || isLoading" @click="processPayment">
        <span v-if="isLoading">处理中...</span>
        <span v-else>开通会员</span>
      </button>
    </section>

    <!-- 支付弹窗（仅移动端） -->
    <div class="payment-modal" v-if="showPaymentModal && isMobile">
      <div class="modal-overlay" @click="closePaymentModal"></div>
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-title">付款金额</span>
          <button class="modal-close" @click="closePaymentModal">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="payment-amount">¥{{ selectedPrice }}</div>
          <div class="payment-methods-modal">
            <div class="method-item" @click="selectPaymentMethod('alipay')" :class="{ selected: selectedPaymentMethod === 'alipay' }">
              <i class="fab fa-alipay"></i>
              <span>支付宝</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="pay-confirm-btn" @click="confirmPayment" :disabled="isLoading">
            <span v-if="isLoading">处理中...</span>
            <span v-else>去支付</span>
          </button>
        </div>
      </div>
    </div>

    <!-- 移动端支付处理中动画 -->
    <div class="payment-processing" v-if="isProcessingPayment && isMobile">
      <div class="processing-overlay"></div>
      <div class="processing-spinner">
        <div class="spinner"></div>
        <span>处理中</span>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store/index";
import userUrl from "@/assets/image/user.svg";
import { mapState } from "vuex";
import { createOrder } from "@/api/pay/index";
import { getVipService, getContinueService } from "@/api/login/index"
import { getBenefits } from "@/api/benefits" 

export default {
  data() {
    return {
      userUrl,
      selectedPlan: 'continuous-quarterly', // 默认选择连续包季
      agreedToTerms: false, // 协议勾选状态
      expandedSections: {
        modelAccess: false,
        videoCall: false
      },
      showPaymentModal: false,
      selectedPaymentMethod: 'alipay', // 默认选中支付宝
      qrCodeUrl: '', // 二维码
      payUrl: '', // 支付链接
      paymentMessage: '', // 支付提示信息
      currentOrderId: '', // 当前订单ID
      isLoading: false, // 通用加载状态
      isLoadingQrCode: false, // 二维码专用加载状态
      qrCodeError: false, // 二维码加载错误状态
      isProcessingPayment: false, // 支付处理中动画状态
      benefits: []
    };
  },
  async mounted() {
    try {
      const res = await getBenefits()
      // 根据你们后端返回的格式取值
      this.benefits = res.data || res
      console.log('权益数据已加载:', this.benefits)
    } catch (error) {
      console.error('加载权益失败:', error)
    }
  },

  computed: {
    ...mapState(["user"]),
    selectedPrice() {
      switch(this.selectedPlan) {
        case 'continuous-monthly': return 99;
        case 'continuous-quarterly': return 267;
        case 'quarterly': return 285;
        case 'yearly': return 948;
        case 'monthly': return 129;
        default: return 129;
      }
    },
    // 判断是否为连续付费套餐
    isContinuousPlan() {
      return ['continuous-monthly', 'continuous-quarterly'].includes(this.selectedPlan);
    },
    // 根据选中的套餐显示不同的说明文字
    disclaimerText() {
      switch(this.selectedPlan) {
        case 'continuous-monthly':
          return '次月以129元/月续费，可随时取消自动续费；首购特惠每个账号仅可享受一次';
        case 'continuous-quarterly':
          return '次季以387元/季续费，可随时取消自动续费；首购特惠每个账号仅可享受一次';
        case 'quarterly':
          return '首购特惠每个账号仅可享受一次';
        case 'yearly':
          return '首购特惠每个账号仅可享受一次';
        case 'monthly':
          return '';
        default:
          return '首购特惠每个账号仅可享受一次';
      }
    },
    // 判断是否为移动端
    isMobile() {
      return window.innerWidth <= 768;
    },
    // 转换会员类型格式以匹配接口要求
    membershipType() {
      const typeMap = {
        'monthly': 'monthly',
        'quarterly': 'quarterly',
        'yearly': 'annual',
        'continuous-monthly': 'monthly_continuous',
        'continuous-quarterly': 'quarterly_continuous'
      };
      return typeMap[this.selectedPlan] || 'monthly';
    },
    // 获取支付类型
    paymentType() {
      return this.isMobile ? 'alipay_mobile' : 'alipay_pc';
    }
  },
  methods: {
    async openContinueService(e) {
      // 先阻止事件冒泡和默认行为
      e.stopPropagation();
      e.preventDefault();
      
      const newWindow = window.open('', '_blank');
      let res = await getContinueService();
      if (!res) return
      newWindow.document.write(res.data);
      newWindow.document.close();
    },

    async openVipService(e) {
      // 先阻止事件冒泡和默认行为
      e.stopPropagation();
      e.preventDefault();
      
      const newWindow = window.open('', '_blank');
      let res = await getVipService();
      if (!res) return
      newWindow.document.write(res.data);
      newWindow.document.close();
    },
    async selectPlan(plan) {
      this.selectedPlan = plan;
      // 桌面端选中套餐后，如果已勾选协议则刷新二维码
      if (!this.isMobile && this.agreedToTerms) {
        await this.getPaymentInfo();
      }
    },
    async getPaymentInfo() {
      // 重置二维码状态
      this.qrCodeUrl = '';
      this.qrCodeError = false;
      this.isLoadingQrCode = true;
      
      try {
        const params = {
          amount: this.selectedPrice,
          membership_type: this.membershipType,
          payment_type: this.paymentType
        };
        
        const response = await createOrder(params);
        const data = response.data || response;
        
        this.currentOrderId = data.orderid;
        // 验证二维码URL有效性
        if (data.qrcode && this.isValidUrl(data.qrcode)) {
          this.qrCodeUrl = data.qrcode;
          this.paymentMessage = data.message || '请扫码完成支付';
        } else {
          throw new Error('无效的二维码地址');
        }
      } catch (error) {
        console.error('获取支付信息失败:', error);
        this.qrCodeError = true;
        this.paymentMessage = '二维码加载失败，请重试';
        this.$toast && this.$toast.error('获取支付信息失败，请重试');
      } finally {
        this.isLoadingQrCode = false;
      }
    },
    // 验证URL有效性
    isValidUrl(url) {
      try {
        new URL(url);
        return true;
      } catch (e) {
        return false;
      }
    },
    toggleExpand(section) {
      this.expandedSections[section] = !this.expandedSections[section];
    },
    closeModal() {
      this.$emit('close');
    },
    processPayment() {
      if (this.agreedToTerms && this.isMobile) {
        this.showPaymentModal = true;
      }
    },
    closePaymentModal() {
      this.showPaymentModal = false;
    },
    selectPaymentMethod(method) {
      this.selectedPaymentMethod = method;
    },
    
    async confirmPayment() {
      if (this.selectedPaymentMethod === 'alipay') {
        this.isLoading = true;
        try {
          const params = {
            amount: this.selectedPrice,
            membership_type: this.membershipType,
            payment_type: this.isMobile ? 'alipay_mobile' : 'alipay_pc'
          };
          
          const response = await createOrder(params);
          const data = response.data || response;
          
          if (data.payurl && this.isValidUrl(data.payurl)) {
            // 显示支付处理中动画
            this.isProcessingPayment = true;
            
            // 10秒后自动关闭动画
            setTimeout(() => {
              this.isProcessingPayment = false;
            }, 10000);
            
            // 支付前取消协议勾选状态
            this.agreedToTerms = false;
            
            // 立即跳转支付链接（与动画并发执行）
            window.location.href = data.payurl;
          } else {
            throw new Error('无效的支付链接');
          }
        } catch (error) {
          console.error('创建支付订单失败:', error);
          this.$toast && this.$toast.error('支付失败，请重试');
          // 错误时关闭动画
          this.isProcessingPayment = false;
        } finally {
          this.isLoading = false;
          this.showPaymentModal = false;
        }
      }
    },
    // 处理协议勾选状态变化
    async handleAgreementChange() {
      // 仅桌面端处理
      if (!this.isMobile) {
        if (this.agreedToTerms) {
          // 勾选协议后获取二维码
          await this.getPaymentInfo();
        } else {
          // 取消勾选后清空二维码
          this.qrCodeUrl = '';
          this.qrCodeError = false;
        }
      }
    }
  },
};
</script>

<style scoped>
/* 原有样式保持不变，新增和修改以下样式 */
.loading {
  width: 120px;
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  border: 1px solid #eee;
  padding: 8px;
  border-radius: 8px;
}

/* 新增：二维码占位符样式 */
.placeholder-message {
  width: 120px;
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  border: 1px solid #eee;
  padding: 8px;
  border-radius: 8px;
  color: #666;
  font-size: 12px;
  text-align: center;
}

.placeholder-message i {
  margin-bottom: 8px;
  font-size: 20px;
}

/* 加载动画 */
.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #6c63ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 8px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 移动端支付处理中动画样式 */
.payment-processing {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.processing-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(2px);
}

.processing-spinner {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.processing-spinner span {
  margin-top: 16px;
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

/* 错误提示样式 */
.error-message {
  width: 120px;
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  border: 1px solid #fee;
  padding: 8px;
  border-radius: 8px;
  color: #e53e3e;
  font-size: 12px;
  text-align: center;
}

.error-message i {
  margin-bottom: 8px;
  font-size: 20px;
}

.qrcode-img {
  width: 180px;
  height: 180px;
  object-fit: contain;
  background-color: white;
  border: 1px solid #eee;
  padding: 8px;
  border-radius: 8px;
}

.title-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  margin-bottom: 10px;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
  text-align: center;
  flex: 1;
}

.title-bar-placeholder {
  width: 40px; /* 与返回按钮宽度保持一致，使标题居中 */
}

/* 容器样式，用于实现滚动效果 */
.vip-subscription-container {
  max-height: 100vh;
  overflow-y: auto;
  padding: 10px;
  /* 为移动端支付区域留出空间 */
  padding-bottom: 120px;
  box-sizing: border-box;
}

/* 基础样式 */
.vip-subscription {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

/* 导航栏样式 */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;
  /* 新增：确保按钮和内容正确对齐 */
  gap: 10px;
}

.page-header {
  display: flex;
  align-items: center;
  background-color: #fff;
  position: relative;

  .back-btn {
    font-size: 20px;
    color: #666;
    cursor: pointer;
    margin-right: 16px;
    background: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
    width: 36px;
    height: 36px;

    &:hover {
      color: #409eff;
      background-color: #f5f7fa;
    }

    &:focus {
      outline: 2px solid rgba(64, 158, 255, 0.3);
      outline-offset: 2px;
    }
  }

  h1 {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    flex: 1;
    text-align: center;
  }
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.head-icon {
  position: relative;
  border: 2px solid #ffffffcc;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.head-icon.head-icon-isBeta {
  width: 40px;
  height: 40px;
  border: 1px solid #deefff;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.user-details {
  display: flex;
  flex-direction: column;
}

.username {
  font-weight: 600;
  color: #333;
}

.user-status {
  font-size: 12px;
  color: #666;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #333;
}

/* 套餐卡片样式 */
.subscription-plans {
  display: flex;
  gap: 16px;
  margin: 20px 0;
  padding: 16px;
  overflow-x: auto;
  scroll-behavior: smooth;
  position: relative;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
}

.subscription-plans::-webkit-scrollbar {
  height: 6px;
}

.subscription-plans::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}

.subscription-plans::-webkit-scrollbar-track {
  background-color: #f5f5f5;
  border-radius: 3px;
}

.plan-card {
  flex: 0 0 auto;
  width: 160px;
  background-color: #f9f9f9;
  border-radius: 12px;
  padding: 20px 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  border: 2px solid transparent;
}

.plan-card.highlighted {
  background-color: #fff8e6;
  border-color: #ffb800;
  box-shadow: 0 8px 16px rgba(255, 184, 0, 0.15);
  transform: none;
}

.tag {
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ff7d00;
  color: white;
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 12px;
  z-index: 10;
}

.plan-type {
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
  margin-top: 8px;
}

.price {
  margin-bottom: 4px;
}

.current-price {
  font-size: 20px;
  font-weight: 700;
  color: #ff3e3e;
}

.original-price {
  font-size: 12px;
  color: #999;
  text-decoration: line-through;
  margin-left: 4px;
}

.period {
  font-size: 12px;
  color: #666;
}

.disclaimer {
  font-size: 12px;
  color:rgb(235, 56, 11);
  text-align: center;
  margin: 16px 0 30px;
  padding: 8px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

/* 权益对比表格 */
.benefits-comparison {
  margin-bottom: 30px;
}

.section-title {
  text-align: center;
  margin-bottom: 24px;
  color: #333;
  font-size: 18px;
  font-weight: 600;
  position: relative;
}

.section-title::before,
.section-title::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 30%;
  height: 1px;
  background-color: #eee;
}

.section-title::before {
  left: 0;
}

.section-title::after {
  right: 0;
}

.comparison-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #f9f9f9;
  border-radius: 12px;
  overflow: hidden;
}

.table-header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr; /* 调整为4列：功能、会员、非会员、新注册用户 */
  background-color: #f0edff;
}

.table-header-cell {
  padding: 12px;
  text-align: center;
  font-weight: 600;
  color: #333;
}

.vip-header {
  color: #6c63ff;
}

.non-vip-header {
  color: #666;
}

.new-user-header { /* 新增：新注册用户列头部样式 */
  color: #ff7d00;
}

.table-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr; /* 调整为4列 */
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
}

.table-row.row-even {
  background-color:rgb(241, 253, 236);
}

.table-row:hover {
  background-color:rgb(243, 240, 205);
}

.row-label {
  padding: 14px;
  font-weight: 500;
  color: #333;
  border-right: 1px solid #eee;
}

.table-cell {
  padding: 14px;
  text-align: center;
  color: #333;
  font-size: 16px; /* 调整emoji大小 */
}

.vip-cell {
  color: #6c63ff;
  position: relative;
  border-right: 1px solid #eee; /* 新增：列分隔线 */
}

.non-vip-cell {
  border-right: 1px solid #eee; /* 新增：列分隔线 */
}

.new-user-cell { /* 新增：新注册用户列单元格样式 */
  color: #ff7d00;
}

.has-expand {
  cursor: pointer;
}

.has-expand .fa-chevron-down,
.has-expand .fa-chevron-up {
  margin-left: 8px;
  font-size: 12px;
}

.expanded-content {
  grid-column: 1 / -1;
  padding: 12px 14px;
  background-color: #f0f0f0;
  font-size: 14px;
  color: #666;
  border-bottom: 1px solid #eee;
}

/* 支付区域样式 */
.payment-section {
  background-color: #f9f9f9;
  border-radius: 12px;
  padding: 20px;
}

.payment-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.total-price {
  font-size: 32px;
  font-weight: 700;
  color: #ff3e3e;
}

.payment-qrcode {
  display: flex;
  align-items: center;
  gap: 16px;
}

.payment-methods {
  display: flex;
  align-items: center;
  gap: 8px;
}

.wechat-icon {
  color: #07c160;
  font-size: 24px;
}

.alipay-icon {
  color: #1677ff;
  font-size: 24px;
}

.scan-text {
  font-size: 14px;
  color: #666;
}

.terms-agreement {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.agreement-label {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  color: #666;
}

.agreement-label input {
  margin-top: 3px;
}

/* 协议链接样式 */
.agreement-link {
  color: #6c63ff;
  text-decoration: underline;
  cursor: pointer;
}

.agreement-link:hover {
  color: #5a53d3;
}

.pay-btn {
  background-color: #6c63ff;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100%;
}

.pay-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pay-btn:not(:disabled):hover {
  background-color: #5a53d3;
}

/* 移动端支付区域样式 */
.mobile-payment-section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  padding: 16px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 支付弹窗样式 */
.payment-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  position: relative;
  background-color: white;
  width: 90%;
  max-width: 400px;
  border-radius: 16px;
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.modal-close {
  background: none;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
}

.modal-body {
  padding: 20px;
}

.payment-amount {
  font-size: 36px;
  font-weight: 700;
  color: #ff3e3e;
  text-align: center;
  margin: 20px 0 30px;
}

.payment-methods-modal {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.method-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  border: 1px solid #eee;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.method-item.selected {
  border-color: #6c63ff;
  background-color: #f0edff;
}

.method-item i {
  font-size: 24px;
}

.method-item .fa-alipay {
  color: #1677ff;
}

.method-item .fa-weixin {
  color: #07c160;
}

.method-item span {
  font-size: 16px;
  color: #333;
}

.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #eee;
}

.pay-confirm-btn {
  width: 100%;
  background-color: #6c63ff;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.pay-confirm-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pay-confirm-btn:not(:disabled):hover {
  background-color: #5a53d3;
}

/* 响应式调整 */
@media (max-width: 768px) {
  /* 移动端显示/隐藏控制 */
  .mobile-only {
    display: block;
  }
  .vip-subscription-container {
  padding-bottom: 250px; /* 增加底部内边距 */
  }
  .desktop-only {
    display: none;
  }
  
  .user-details .username {
    font-size: clamp(14px, 4vw, 18px);
  }
  
  .user-details .user-status {
    font-size: clamp(12px, 3vw, 14px);
  }
  
  .payment-info {
    flex-direction: column;
    gap: 20px;
  }
  
  .total-price {
    font-size: 28px;
  }

  /* 权益对比表格适配 */
  .comparison-table {
    font-size: 14px;
  }
  
  .row-label {
    padding: 10px 8px;
    font-size: 13px;
  }
  
  .table-cell {
    padding: 10px 5px;
    font-size: 14px;
  }

  /* 套餐卡片适配 */
  .plan-card {
    width: 140px;
    padding: 15px 10px;
  }
  
  .plan-type {
    font-size: 14px;
  }
  
  .plan-card .plan-type {
    margin-bottom: 0px; /* 调整套餐类型与价格之间的距离（值越大间距越大） */
  }

  .plan-card .price {
    margin-top: 0px; /* 也可通过价格区域的上外边距微调 */
  }

  .current-price {
    font-size: 18px;
  }
}

@media (min-width: 769px) {
  /* 桌面端显示/隐藏控制 */
  .mobile-only {
    display: none;
  }
  
  .desktop-only {
    display: flex;
  }
}

@media (max-width: 480px) {
  .subscription-plans {
    padding: 10px 0;
    gap: 10px;
  }
  
  .plan-card {
    width: 120px;
  }

  .section-title {
    font-size: 16px;
  }
  
  .expanded-content {
    font-size: 12px;
    padding: 8px 10px;
  }
  
  .qrcode-img {
    width: 100px;
    height: 100px;
  }
  
  .pay-btn {
    font-size: 15px;
    padding: 10px;
  }
  
  /* 移动端协议文本换行调整 */
  .agreement-label {
    flex-wrap: wrap;
  }

  /* 移动端表格适配 */
  .table-header {
    grid-template-columns: 1.2fr 0.8fr 0.8fr 0.8fr; /* 调整移动端表格列宽 */
  }
  .table-row {
    grid-template-columns: 1.2fr 0.8fr 0.8fr 0.8fr; /* 调整移动端表格列宽 */
  }
  .row-label {
    padding: 8px 6px;
    font-size: 12px;
  }
  .table-cell {
    padding: 8px 4px;
    font-size: 14px;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  /* 容器底部内边距重置（移动端为250px，桌面无需过大） */
  .vip-subscription-container {
    padding-bottom: 20px;
  }

  /* 套餐卡片：适当缩小宽度，提升横向浏览体验 */
  .plan-card {
    width: 140px;
    padding: 15px 12px;
  }
  .current-price {
    font-size: 18px;
  }

  /* 支付区域：改为纵向排列，适应中等宽度屏幕 */
  .payment-info {
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
  .total-price {
    font-size: 28px;
  }
  .payment-qrcode {
    flex-direction: column;
    align-items: center;
  }
  .qrcode-img {
    width: 150px;
    height: 150px;
  }

  /* 权益表格：微调字体和间距 */
  .comparison-table {
    font-size: 13px;
  }
  .row-label {
    padding: 10px 8px;
    font-size: 12px;
  }
  .table-cell {
    padding: 10px 6px;
    font-size: 13px;
  }

  /* 协议文字略小，避免折行 */
  .agreement-label {
    font-size: 11px;
  }
}

</style>